<script lang="ts">
	let {
		title = 'Error',
		message,
		onRetry,
		retryText = 'Try again',
		class: className = ''
	}: {
		title?: string;
		message: string;
		onRetry?: () => void;
		retryText?: string;
		class?: string;
	} = $props();
</script>

<div class="mb-6 rounded-lg bg-red-50 p-4 {className}">
	<div class="flex">
		<div class="ml-3">
			<h3 class="text-sm font-medium text-red-800">{title}</h3>
			<div class="mt-2 text-sm text-red-700">
				<p>{message}</p>
			</div>
			{#if onRetry}
				<div class="mt-4">
					<button
						onclick={onRetry}
						class="rounded-md bg-red-100 px-3 py-2 text-sm font-medium text-red-800 transition-colors hover:bg-red-200"
					>
						{retryText}
					</button>
				</div>
			{/if}
		</div>
	</div>
</div>
